const AUTH_GROUPS = Object.freeze({
  ADMIN: 'Admin',
  GATEKEEPER: 'Gatekeeper',
  CLIENT: 'Clients',
  ALL: 'ALL',
});

export default AUTH_GROUPS;
